import PropTypes from 'prop-types';
import { CommentButton } from './CommentButton';
import { ShareButton } from './ShareButton';
import { Votes } from './Votes';

export function ThreadFooter({
  upvotes,
  downvotes,
  commentsCount,
  isUpvoted,
  isDownvoted,
  handleUpvoteAction,
  handleDownvoteAction,
  handleCommentAction,
  handleShareAction,
}) {
  return (
    <div className="mt-2 flex items-center justify-between gap-2 text-xs opacity-90 group-hover:opacity-100 sm:text-sm 2xl:text-sm">
      <Votes
        upvotes={upvotes}
        downvotes={downvotes}
        isUpvoted={isUpvoted}
        isDownvoted={isDownvoted}
        handleUpvoteButton={handleUpvoteAction}
        handleDownvoteButton={handleDownvoteAction}
      />
      <CommentButton
        handleClick={handleCommentAction}
        commentsCount={commentsCount}
      />
      <ShareButton handleClick={handleShareAction} />
    </div>
  );
}

ThreadFooter.propTypes = {
  upvotes: PropTypes.arrayOf(PropTypes.string).isRequired,
  downvotes: PropTypes.arrayOf(PropTypes.string).isRequired,
  commentsCount: PropTypes.number.isRequired,
  isUpvoted: PropTypes.bool,
  isDownvoted: PropTypes.bool,
  handleUpvoteAction: PropTypes.func.isRequired,
  handleDownvoteAction: PropTypes.func.isRequired,
  handleCommentAction: PropTypes.func.isRequired,
  handleShareAction: PropTypes.func.isRequired,
};
